import { Injectable } from '@angular/core';
import {
    CanActivateChild,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ClinicDetailQuery } from '../state/clinic-detail/clinic-detail.query';
import { SettingsQuery } from '../state/settings/settings.query';

@Injectable({
    providedIn: 'root',
})
export class ParentSystemkeyGuard implements CanActivateChild {
    constructor(
        private clinicDetailQuery: ClinicDetailQuery,
        private settingsQuery: SettingsQuery,
        private router: Router
    ) {}
    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        /** TODO: PREGUNTAR A CRISTIAN */
        const paramClinicId = state.url.split('/')[2];
        if (
            this.clinicDetailQuery.id === paramClinicId &&
            this.settingsQuery.parentSystemKey &&
            state.url.indexOf('parentSystemKey') === -1
        ) {
            let parentSystemKeyQueryParams = '';
            parentSystemKeyQueryParams =
                '?parentSystemKey=' + this.settingsQuery.parentSystemKey;

            return this.router.parseUrl(state.url + parentSystemKeyQueryParams);
        }
        return true;
    }
}
